import { get } from '@/services/http';
import { LoginRequestModel } from '@/models/login_request';
import List from './list';

export class LoginRequestList extends List<LoginRequestModel> {
  public merchantId?: number;

  public async fetchPending(merchantId: number) {
    this.merchantId = merchantId;
    const response: any = await get(`/merchants/${merchantId}/login-requests/pending`, {});
    const requests: any[] = response?.data ?? [];
    this.items = []; // Clear existing items
    for (const r of requests) {
      const request = new LoginRequestModel();
      request.mapData(r);
      this.add(request);
    }
  }

  public async checkForPending(merchantId: number): Promise<LoginRequestModel | null> {
    await this.fetchPending(merchantId);
    return this.items.length > 0 ? this.items[0] : null;
  }
}
